export const CITY_OBJCT = 'CITY_OBJCT'//城市对象
export const CHECK_DATE_OBJECT = 'CHECK_DATE_OBJECT'//日期对象



// WEBPACK FOOTER //
// ./src/store/object-types.js